import { useMemo } from 'react';

import { ServerErrors } from '@app/common/types/validation';
import { ValidationUnion } from '@app/queryTyping';
import { isNotEmptyArray } from '../assertion';
import { getServerErrors } from '.';

/**
 * Returns server fields and common errors based on ValidationUnion
 */
export const useServerErrors = (errors?: Array<ValidationUnion | null>): ServerErrors => (
  useMemo<ServerErrors>(() => {
    if (isNotEmptyArray(errors)) {
      return getServerErrors(errors);
    }

    return { fieldErrors: [], genericErrors: [] };
  }, [errors])
);
